import { render } from "./CometChatOutgoingCall.vue?vue&type=template&id=bfdbf14a&scoped=true"
import script from "./CometChatOutgoingCall.vue?vue&type=script&lang=js"
export * from "./CometChatOutgoingCall.vue?vue&type=script&lang=js"

import "./CometChatOutgoingCall.vue?vue&type=style&index=0&id=bfdbf14a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfdbf14a"]])

export default __exports__